export const FREE_TRIAL_PRICE = 0;
export const FREE_TRIAL_CURRENCY = 'EUR';
export const FREE_TRIAL_DURATION_IN_MINUTES = 15;
